import OrganizationsAPI from '~/services/api/OrganizationsAPI';
import {
  SET_ORGANIZATION,
  SET_ORGANIZATION_DOCUMENTS,
  SET_ORGANIZATION_SETTINGS,
} from '~/store/organizations/mutation-types';

export async function fetchOrganization({ commit }, id) {
  try {
    const organization = await OrganizationsAPI.getOrganization(id);
    commit(SET_ORGANIZATION, organization.data);
    return Promise.resolve(organization.data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function fetchOrganizationDocuments({ commit }, id) {
  try {
    const documents = await OrganizationsAPI.getOrganizationDocument(id);
    commit(SET_ORGANIZATION_DOCUMENTS, documents?.data?.data);
    return Promise.resolve(documents?.data?.data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function fetchOrganizationSettings({ commit }, id) {
  try {
    const settings = await OrganizationsAPI.getOrganizationSettings(id);
    commit(SET_ORGANIZATION_SETTINGS, settings);
    return Promise.resolve(settings);
  } catch (error) {
    return Promise.reject(error);
  }
}
